import React from "react";
import { Input, Button, message } from 'antd'
import './index.sass';
import api from "../../../../utils/api";


export default class ClassifyEditor extends React.Component {
    constructor(props) {
        super(props)

        console.log(props)

        let item = props.showClassify ? props.showClassify.item : null

        this.state = {
            classifyParam: props.showClassify,
            classifyName: item ? item.name : ''
        }

    }

    closeHandle = () => {
        this.props.colsePop({ show: false })
    }

    componentWillReceiveProps() {
        console.log(this.props)
    }

    addNewClassify = async () => {

        let { classifyName } = this.state;
        if (!classifyName) return message.error('请填写分类名称')

        let param = {
            cate: classifyName
        }
        let res = await api('add-cate', param);
        if (res.code === 200) { message.success(res.message); this.closeHandle(); this.props.update(true) } else { message.error(res.message) }
        console.log(res);
    }

    changeClassifyName = (e) => {
        this.setState({
            classifyName: e.target.value
        })
    }

    changeClassify = async (params) => {//编辑分类

        let { classifyName } = this.state;

        let param = {
            cate_id: params.item.id,
            name: classifyName
        }
        let res = await api('update-cates', param)
        if (res.code === 200) { message.success('修改成功！'); this.props.update(true); this.closeHandle(); } else { message.error(res.message) }


        console.log(res)

    }



    render() {
        let { classifyParam, classifyName } = this.state
        return (
            <div className='classifyEditor'>
                <div className='close'></div>

                <div className='popBox'>
                    <p className='title'>
                        {classifyParam.item ? '编辑分类' : '新建分类'}
                    </p>


                    <div className='popContent'>
                        <div className='popCtx'>
                            <div className='flex line alignCenter'>
                                <label>分类名称：</label>
                                <Input onChange={(e) => { this.changeClassifyName(e) }} value={classifyName} className='width260' width={260} placeholder="请输入分类名称，最多20字" />
                            </div>

                            <div className='flex line contrlBtn'>

                                {
                                    classifyParam.item ? (<Button onClick={() => { this.changeClassify(classifyParam) }} className='themeBtn'>修改</Button>) : (<Button onClick={() => { this.addNewClassify() }} className='themeBtn'>保存</Button>)
                                }

                                <Button onClick={() => { this.closeHandle() }}>取消</Button>


                            </div>
                        </div>

                    </div>
                </div>

            </div>
        )
    }


}